import React, { useRef, useEffect} from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react"
import { LoginButton }  from '../Login/Login'
import { LogoutButton }  from '../Login/Logout'
import { Profile }  from '../Login/Profile'

import './header.scss';


const headerNav = [
    {
        display: 'Home',
        path: '/'
    },
    {
        display: 'Películas',
        path: '/movie'
    },
    {
        display: 'Series',
        path: '/tv'
    }
];

const Header = () => {

    const { pathname } = useLocation();
    const headerRef = useRef(null);

    const active = headerNav.findIndex(e => e.path === pathname);
    const { isAuthenticated } = useAuth0();

    useEffect(() => {
        const shrinkHeader = () => {
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                headerRef.current.classList.add('shrink');
            } else {
                headerRef.current.classList.remove('shrink');
            }
        }
        window.addEventListener('scroll', shrinkHeader);
        return () => {
            window.removeEventListener('scroll', shrinkHeader);
        };
    }, []);

    return (
        <div ref={headerRef} className="header">
            <div className="header__wrap container">
                <div className="logo">
                    <Link to="/">MoviesPlus</Link>
                </div>
                
                <ul className="header__nav">
                    {
                        headerNav.map((e, i) => (
                            <li key={i} className={`${i === active ? 'active' : ''}`}>
                                <Link to={e.path}>
                                    {e.display}
                                </Link>
                            </li>
                        ))
                    }
                    
                </ul>
                <div className="">
                    { isAuthenticated ? <>
                    <div className="profile col-md-2"> 
                    <Profile />
                    </div>
                    < LogoutButton />
                    </> : 
                    < LoginButton />
                    }
                    
                </div>
            </div>
        
        </div>
        

    );
}

export default Header;
